import { useCallback } from 'react';

/* eslint-disable @typescript-eslint/ban-types */
const actions = {
    init: 'init',
    setRowClicked: 'setRowClicked',
};
const reducer = (state, action) => {
    if (action.type === actions.init) {
        return Object.assign(Object.assign({}, state), { clickedRowId: null });
    }
    if (action.type === actions.setRowClicked) {
        return Object.assign(Object.assign({}, state), { clickedRowId: action.rowId });
    }
};
const prepareRow = (row, { instance }) => {
    row.setRowClicked = () => instance.setRowClicked(row.id);
    row.resetRowClicked = () => instance.resetRowClicked();
};
const useInstance = (instance) => {
    const { dispatch } = instance;
    const setRowClicked = useCallback((rowId) => {
        dispatch({
            type: actions.setRowClicked,
            rowId,
        });
    }, [dispatch]);
    const resetRowClicked = useCallback(() => {
        dispatch({
            type: actions.setRowClicked,
            rowId: undefined,
        });
    }, [dispatch]);
    Object.assign(instance, {
        setRowClicked,
        resetRowClicked,
    });
};
const useRowClick = (hooks) => {
    hooks.stateReducers.push(reducer);
    hooks.useInstance.push(useInstance);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    hooks.prepareRow.push(prepareRow);
};

export { actions, useRowClick as default };
//# sourceMappingURL=useRowClick.js.map
